import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const dashboardNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Dashboard,
  icon: 'home',
  route: `/${RoutesEnum.Dashboard}`,
};
